export default __webpack_public_path__ + "7112085.png";